export default "__VITE_ASSET__XfoVNO2c__"